import { AbstractControl, ValidationErrors } from '@angular/forms';

export function passwordValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value || '';
  const errors: any = {};

  if (value.length === 0) return null;
  
  if (value.length < 14) errors.minLength = true;
  if (!/[A-Z]/.test(value)) errors.noUppercase = true;
  if (!/[a-z]/.test(value)) errors.noLowercase = true;
  if (!/[0-9]/.test(value)) errors.noNumber = true;
  if (!/[.*@#&!%_+\/\-?^${}()]/.test(value)) errors.noSpecial = true;

  return Object.keys(errors).length ? errors : null;
}


// WEBPACK FOOTER //
// ./src/app/shared/validators/password.validator.ts